"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var single_1 = require("./modules/showtg/single");
var triple_1 = require("./modules/showtg/triple");
var style_css_1 = __importDefault(require("./style.css"));
var add_style_1 = require("./modules/add_style");
var getdata_1 = require("./modules/getdata");
var cookie_1 = __importDefault(require("./modules/cookie"));
var from_search_1 = require("./modules/from_search");
var two_1 = require("./modules/showtg/two");
function websitepoptg() {
    //判断是否是搜索引起来源
    var isfromsearch = (0, from_search_1.isFromSearch)();
    if (!isfromsearch)
        return false;
    var rootdomain = '.eastmoney.com';
    var hostname = self.location.hostname.toLowerCase();
    if (hostname.indexOf('eastmoney.com') < 0) {
        if (hostname.indexOf('18.cn') >= 0) {
            rootdomain = '.18.cn';
        }
        else if (hostname.indexOf('xzsec.com') >= 0) {
            rootdomain = '.xzsec.com';
        }
    }
    //判断获取条件 一天之内不调用接口
    var websitepoptg_api_time = cookie_1["default"].get('websitepoptg_api_time');
    if (websitepoptg_api_time) {
        if ((new Date()).getTime() - parseInt(websitepoptg_api_time) < (24 * 60 * 60 * 1000)) {
            return false;
        }
    }
    //记录获取时间
    cookie_1["default"].set('websitepoptg_api_time', (new Date()).getTime().toString(), 2, rootdomain);
    //获取数据
    (0, getdata_1.getData)(function (data) {
        // data = {
        //     "status": 0,
        //     "msg": "操作成功",
        //     "costTime": 8,
        //     "data": {
        //         "adPositionData": {
        //             "eid": 221000007231732013,
        //             "intervalDay": 2,
        //             "posCode": "downloadapp",
        //             "list": [{
        //                 "imgUrl": ["https://mobappconfig.securities.eastmoney.com/appimg/52f7b6f7-d87f-42c3-aa85-0bdcec420aac.png", "https://mobappconfig.securities.eastmoney.com/appimg/93250cf5-5f41-4293-ad68-d0ecaf5c0333.png", "https://mobappconfig.securities.eastmoney.com/appimg/06ee584f-3b5d-4582-ac07-7f33c7a95955.png"],
        //                 "eid": "221000007231834276",
        //                 "tpCode": "triple",
        //                 "weight": 1,
        //                 "startTime": "2023-08-22 09:07:50",
        //                 "endTime": "2023-08-26 00:00:00",
        //                 "title": "5"
        //             }],
        //             "type": 0
        //         }
        //     }
        // }
        var _a, _b, _c, _d, _e;
        // data = {
        //   status: 0,
        //   msg: "操作成功",
        //   costTime: 1,
        //   data: {
        //     adPositionData: {
        //       eid: 223000003332646980,
        //       intervalDay: 1,
        //       posCode: "downloadapp",
        //       list: [
        //         {
        //           imgUrl: [
        //             "https://emfiletest.eastmoney.com/appimg/084a20d0-4010-4f38-8c6a-65382ee6a5d9.png",
        //           ],
        //           eid: "223000003332649045",
        //           tpCode: "single",
        //           weight: 1,
        //           startTime: null,
        //           endTime: null,
        //           title: "单图第一个素材",
        //         },
        //       ],
        //       type: 0,
        //     },
        //   },
        // };
        // data = {
        //   status: 0,
        //   msg: "操作成功",
        //   costTime: 1,
        //   data: {
        //     adPositionData: {
        //       eid: 223000003332646980,
        //       intervalDay: 1,
        //       posCode: "downloadapp",
        //       list: [
        //         {
        //           imgUrl: [
        //             "https://emfiletest.eastmoney.com/appimg/f68230b4-77b6-4f0e-8af9-d116e6496209.png",
        //             "https://emfiletest.eastmoney.com/appimg/a801d6dd-9196-4ba1-933d-783754da2cec.png",
        //           ],
        //           eid: "223000003352950412",
        //           tpCode: "two",
        //           weight: 2,
        //           startTime: "2023-10-01 00:00:00",
        //           endTime: "2023-10-20 00:00:00",
        //           title: "两个红包",
        //         },
        //       ],
        //       type: 0,
        //     },
        //   },
        // }
        var intervalDay = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.adPositionData) === null || _b === void 0 ? void 0 : _b.intervalDay;
        var tgdata = (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.adPositionData) === null || _d === void 0 ? void 0 : _d.list) === null || _e === void 0 ? void 0 : _e[0];
        var websitepoptg_show_time = cookie_1["default"].get('websitepoptg_show_time');
        if (intervalDay && websitepoptg_show_time) {
            if ((new Date()).getTime() - parseInt(websitepoptg_show_time) < (24 * 60 * 60 * 1000 * parseInt(intervalDay))) {
                return false;
            }
        }
        if (intervalDay && tgdata) {
            //展示时间
            cookie_1["default"].set('websitepoptg_show_time', (new Date()).getTime().toString(), 60, rootdomain);
            (0, add_style_1.addStyle)(style_css_1["default"]);
            if (tgdata.tpCode == 'single' && tgdata.eid && tgdata.imgUrl instanceof Array && tgdata.imgUrl.length > 0) { //单张
                (0, single_1.showSingle)(tgdata);
            }
            else if (tgdata.tpCode == 'triple' && tgdata.eid && tgdata.imgUrl instanceof Array && tgdata.imgUrl.length >= 3) { //红包 三张
                (0, triple_1.showTriple)(tgdata);
            }
            else if (tgdata.tpCode == 'two' && tgdata.eid && tgdata.imgUrl instanceof Array && tgdata.imgUrl.length >= 2) { //红包 两张
                (0, two_1.showTwo)(tgdata);
            }
        }
    });
}
//TODO: IE9判断
if (window.websitepoptg === undefined) {
    //@ts-ignore 过滤掉老旧IE
    if (document.addEventListener) {
        window.websitepoptg = websitepoptg;
        window.websitepoptg();
    }
}
